import React, { useEffect, useRef, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { compareText } from '../comparators/compareText';
import { TextFilter } from '../filters/TextFilter';
import { debounce } from 'lodash';
import { Editor as TINYEditor } from '@tinymce/tinymce-react';
import { v4 as uuidv4 } from 'uuid';

export const RichTextField: FieldComponent<string, string[]> = ({
  intent,
  isActive,
  onChange,
  value,
  hasTooltip,
  disabled,
  mui,
  isAddingNew,
}) => {
  const debouncedOnChange = debounce(handleDebouncedOnChange, 700);
  function handleDebouncedOnChange(value: any) {
    onChange(value);
  }
  const [key, setKey] = useState<any>();

  const editorRef = useRef<any>(null);
  useEffect(() => {
    setKey(uuidv4());
  }, []);

  useEffect(() => {
    if (editorRef.current && !isAddingNew) {
      editorRef.current.props.value = value;
    }
  }, [value]);

  if (mui) {
    return isAddingNew ? (
      <>
        <TINYEditor
          key={key}
          apiKey="ybzq1vuq9wkhay9gtgokp094t2hl8n4oe51iwicxpzeaim2a"
          onInit={(evt, editor) => (editorRef.current = editor)}
          initialValue={value}
          init={{
            height: 300,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount',
            ],
            toolbar:
              'undo redo | formatselect | ' +
              'bold italic backcolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help',
            content_style:
              'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
          }}
          onEditorChange={(e, a) => {
            debouncedOnChange(a.getContent());
          }}
        />
      </>
    ) : (
      <>

      </>
    );
  }

  if (isActive) {
    return (
      <>

      </>
    );
  }
  return (
    <>

    </>
  );
};

RichTextField.includes = (query = [], value = '') => {
  if (query.length === 0 || value === null) return true;
  const valueLowercase = value.toLowerCase();
  return query.some((queryPart) =>
    valueLowercase.includes(queryPart.toLowerCase())
  );
};

RichTextField.comparator = compareText;

RichTextField.FilterRenderer = TextFilter;
